import type { IconSvgObject } from './types';

const GreekHelmetIcon: IconSvgObject = [
  ["path", { d: "M9 14C7 14 5.83322 17.6296 5.99988 19C4.14859 17.1983 3 14.6877 3 11.9107C3 6.76284 7 2 12.9996 2V4.9619L15.2885 3.08377C15.7401 2.71326 16.337 2.54189 16.8921 2.72376C18.8138 3.35343 20.1059 4.77286 21 5.95459C21 5.95459 17.5 6.4881 16.9994 8.93266", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20.5003 13.5C20.5003 10 17.7794 8 14.5043 8C9.91288 8 7.50746 13.5 10.004 18L9.00625 22L16.5023 20L21 22L20.5003 17C19.5008 17 18.0016 17 16.5023 15.5C17.5018 14 19.6154 13.5 20.5003 13.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default GreekHelmetIcon;
